const mutations = {
  SET_QUANTITY_BY_PRODUCT(state, value) {
    state.quantityByProduct = {
      ...value,
    }
  }
}

export default mutations
